import * as React from 'react';
import { get } from 'lodash';
import useCurrentLanguage from '@lib/hooks/useCurrentLanguage';
import { Language } from '@lib/resources/types';

function getSpecialInstructions(resource: any, language: Language): string {
  return (
    get(resource, `specialInstructionsTemplates.${language}`) ||
    get(resource, 'specialInstructionsTemplates.en') ||
    get(resource, 'specialInstructions')
  );
}

export default function useSpecialInstructions(resource: any) {
  const language = useCurrentLanguage();

  const specialInstructions = React.useMemo(
    () =>
      [
        getSpecialInstructions(resource.type, language) || getSpecialInstructions(resource.appointmentType, language),
        getSpecialInstructions(resource.provider, language),
        getSpecialInstructions(resource.facility, language),
      ].filter(Boolean),
    [resource.appointmentType, resource.facility, resource.provider, resource.type, language],
  );

  return specialInstructions;
}
